<canvas #canvas id="canvas" style="width: 600px; height: 400px;">
</canvas>